/**
 * @enum CurrencyCode
 * @description All possible currency codes will be defined here
 */
enum CurrencyCode {
  USD = "USD",
  EUR = "EUR",
  GBP = "GBP",
  AUD = "AUD",
  SGD = "SGD"
}

export default CurrencyCode;
